// extracted by mini-css-extract-plugin
export var component = "FootnoteList-module--component--191d0";
export var fadePop = "FootnoteList-module--fade-pop--80eb6";
export var footnoteKey = "FootnoteList-module--footnoteKey--d4de9";
export var footnoteRow = "FootnoteList-module--footnoteRow--9eed5";
export var growHeightIn = "FootnoteList-module--grow-height-in--8b45a";